module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "youtube.b6ae1d6f.svg";